import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import ListRoundedIcon from "@mui/icons-material/ListRounded";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import BlurOnIcon from "@mui/icons-material/BlurOn";

const Header = (propse) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    if (e === "Register") {
      propse.setLogin(false);
      propse.setRegister(true);
      propse.setMoreInfo(false);
      propse.setExtra(true);
    }
    if (e === "Login") {
      propse.setLogin(true);
      propse.setRegister(false);
      propse.setMoreInfo(false);
      propse.setExtra(true);
    }
    setAnchorEl(null);
  };
  const options = ["Login", "Register"];
  const ITEM_HEIGHT = 48;
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          minHeight: "40px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <Box sx={{ display: propse.Width < 560 ? "flex" : "none" }}>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? "long-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <ListRoundedIcon sx={{ color: "#000" }} />
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "20ch",
              },
            }}
          >
            {options.map((option) => (
              <MenuItem
                key={option}
                selected={option === "Pyxis"}
                onClick={() => handleClose(option)}
                sx={{
                  height: "50px",
                  fontFamily: "Poppins",
                  fontSize: "0.8rem",
                  transition: "0.3s",
                  color: "#707070",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "rgba(255,195,0,0.2)")
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#FFF")}
              >
                {option === "Register" ? (
                  <CloudQueueIcon
                    sx={{
                      fontSize: "1.3rem",
                      marginRight: "8px",
                    }}
                  />
                ) : (
                  <BlurOnIcon
                    sx={{
                      fontSize: "1.3rem",
                      marginRight: "8px",
                    }}
                  />
                )}
                {option}
              </MenuItem>
            ))}
          </Menu>
        </Box>
        <Box sx={{ display: propse.Width < 560 ? "none" : "flex" }}>
          <Box
            className="AUL"
            sx={{ marginRight: "6px", cursor: "pointer" }}
            onClick={() => handleClose("Login")}
          >
            Login
          </Box>
          <Box>|</Box>
          <Box
            className="AUL"
            sx={{
              marginLeft: "6px",
              cursor: "pointer",
              marginRight:
                propse.Width >= 560 && propse.Width < 650 ? "15px" : "25px",
            }}
            onClick={() => handleClose("Register")}
          >
            Register
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Header;
